import { Box } from './Box';
import type { ReactElement } from 'react';

export const chartSwatchSizePx = 12;
export const chartSwatchRadiusPx = 3;
export const chartSwatchContainerWidthPx = 20;

type ChartSwatchProps = {
  color: string | undefined;
};

export const ChartSwatch = ({ color }: ChartSwatchProps): ReactElement => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      width: chartSwatchSizePx,
      height: chartSwatchSizePx,
      borderRadius: `${chartSwatchRadiusPx}px`,
      backgroundColor: color ?? 'text.secondary',
      flexShrink: 0,
      overflow: 'hidden',
      verticalAlign: 'middle',
    }}
  />
);
